var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-empty-state',{staticClass:"md-primary",attrs:{"md-icon":"check_box_outline_blank","md-label":"Está Vazio","md-description":"Não há nenhum conteúdo cadastrado!"}})}
var staticRenderFns = []

export { render, staticRenderFns }